<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-reconnaissance-arm-canada/"
    paramsName="ARM_Canada"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component
        :is="path"
        :sas="sas"
        @validation-changed="setState(path, $event)"
        :ref="path"
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"
import Identification from "@/components/Formulaires/DemandeReconnaissanceArmCanada/Identification"
import FormationAcademique from "@/components/Formulaires/DemandeReconnaissanceArmCanada/FormationAcademique"
import OrdreProfessionnel from "@/components/Formulaires/DemandeReconnaissanceArmCanada/OrdreProfessionnel"
import ExperienceProfessionnelle from "@/components/Formulaires/DemandeReconnaissanceArmCanada/ExperienceProfessionnelle"
import AutresExigences from "@/components/Formulaires/DemandeReconnaissanceArmCanada/AutresExigences"
import Declaration from "@/components/Formulaires/DemandeReconnaissanceArmCanada/Declaration"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-reconnaissance-arm-canada",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "formation-academique", code: "titre-etape-2", state: "" },
        { path: "ordre-professionnel", code: "titre-etape-3", state: "" },
        { path: "experience-professionnelle", code: "titre-etape-4", state: "" },
        { path: "autres-exigences", code: "titre-etape-5", state: "" },
        { path: "declaration", code: "titre-etape-6", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    FormationAcademique,
    OrdreProfessionnel,
    ExperienceProfessionnelle,
    AutresExigences,
    Declaration
  }
}
</script>
